import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        <li>
          <Link to="/" className="text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
            <i className="ri-home-4-line mr-1"></i>
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-200 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function getCategoryBreadcrumb(slug: string): BreadcrumbItem[] {
  if (slug === 'all') return [{ label: '全部漫画' }];
  const cat = categories.find((c) => c.slug === slug);
  return [{ label: cat?.name || slug, href: `/category/${slug}` }];
}

export function getComicBreadcrumb(comic: { title: string; category: string }): BreadcrumbItem[] {
  const cat = categories.find((c) => c.slug === comic.category);
  return [
    { label: cat?.name || comic.category, href: `/category/${comic.category}` },
    { label: comic.title },
  ];
}